import { Grid, Typography } from "@mui/material";

const GoogleCallback = () => {
  return (
    <Grid container justifyContent={"center"} alignItems={"center"}>
      <Grid item>
        <Typography variant="h1">Logging using Google...</Typography>
      </Grid>
    </Grid>
  );
};

export default GoogleCallback;
